// extracted by mini-css-extract-plugin
export var ScrollToReadControls = "ScrollToRead-module--ScrollToReadControls--o1etX";
export var ScrollToReadcircleContainer = "ScrollToRead-module--ScrollToReadcircleContainer--6oC72";